function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { sortBy, pick, get as safeGet } from "lodash";
import { context, updateContextState } from "../../components/wr-context";
import camelCaseObject from "../../utils/camelcase-object";
import { uniqueArrayById } from "../../utils/array";
import { dedupeCategories } from "../../utils/categories";
import safeJsonParse from "../../utils/safe-json-parse";
import { flattenPhase, resolvePhase } from "../phases/utils";
export var transformProduct = function(_item) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _supplierName = ref.supplierName, supplierName = _supplierName === void 0 ? "" : _supplierName, _catalogId = ref.catalogId, catalogId = _catalogId === void 0 ? "" : _catalogId, order = ref.order;
    var item = camelCaseObject(_item);
    item.order = order !== null && order !== void 0 ? order : item.order;
    var rowsInHeader = [];
    var customSearchable = "";
    var priceValue = 0;
    var priceLabel = "";
    if (supplierName) {
        item.supplierName = supplierName;
        item.supplierId = catalogId;
    }
    if (!item.categories || item.categories && !item.categories.length) {
        item.categories = [
            {
                id: "category-undefined",
                value: "category-undefined",
                label: "Other Products",
                name: "Other Products",
                pos: Number.POSITIVE_INFINITY
            }, 
        ];
    }
    // Use default "Main" tab name or the specified label
    var tabs = [
        (item.mainTabLabel || "").trim() ? item.mainTabLabel : "Main"
    ];
    var currentTab = 0;
    // Some side effects included here to avoid additional loops
    var rows = item.rows || item.productRows;
    var validRows = rows.filter(function(row) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        // Parse price
        if (row.label === "Pricing and Duration") {
            var control = safeJsonParse(row.control, row.control);
            if (typeof control !== "string" && control.schedule) {
                item.serviceRateCents = control.schedule.cost;
                item.duration = control.schedule.duration / 3600;
            }
        }
        if (row.control) {
            row.control = typeof row.control === "string" ? safeJsonParse(row.control, row.control) : row.control;
        }
        // Validate row
        switch(row.rowType){
            case "component:catalog":
            case "component:sow":
                return false;
            case "radio":
                var ref6;
                if (!row.control && !((ref6 = row.options) === null || ref6 === void 0 ? void 0 : ref6.hasQuestionnaire)) {
                    return false;
                }
                break;
            case "editor":
                {
                    var ref7;
                    var control1 = row.control || ((ref7 = row.options) === null || ref7 === void 0 ? void 0 : ref7.defaultValue);
                    if (!control1 || !control1.trim().length) {
                        return false;
                    }
                }
                break;
            case "documents":
            case "component:faqs":
                if (!row.control || !row.control.length) {
                    return false;
                }
                break;
            case "component:phase":
                if (row.parsedControl) {
                    var hoursRow = rows.find(function(r) {
                        var ref;
                        return ((ref = r.options) === null || ref === void 0 ? void 0 : ref.tag) === '(defaultValue "hours")';
                    });
                    item.phase = resolvePhase(row.parsedControl, Number(hoursRow === null || hoursRow === void 0 ? void 0 : hoursRow.control) || 0);
                    item.phasesBreakdown = flattenPhase(item.phase);
                }
                break;
        }
        // Parse tabs
        if (((ref = row.options) === null || ref === void 0 ? void 0 : ref.access) !== "hidden" && (((ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.access) !== "private" || context.state.isLoggedIn)) {
            var ref8;
            if (((ref8 = row.options) === null || ref8 === void 0 ? void 0 : ref8.addToCatalogTab) === true) {
                tabs.push(row.label);
                currentTab += 1;
            } else {
                if (row.rowType === "style:header") {
                    currentTab = 0;
                }
                row.tab = tabs[currentTab];
            }
        }
        if (context.state.pointSystem && row.rowType === "component:pricing") {
            if (typeof row.control === "string") {
                if (row.control === "") {
                    priceValue = 0;
                    priceLabel = "";
                }
            } else {
                priceLabel = row.control && row.control.schedule ? row.control.schedule.serviceRateLabel : "0";
                priceValue = priceLabel ? priceLabel.replace(/\D+/g, "") : 0;
            }
        }
        // Assign unique IDs to items
        if ((ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.items) {
            var ref9;
            (ref9 = row.options) === null || ref9 === void 0 ? void 0 : ref9.items.forEach(function(v) {
                try {
                    var value = safeJsonParse(v.value);
                    if (typeof value !== "string") {
                        var ref;
                        value.id = v.id;
                        value.tag = ((ref = row.options) === null || ref === void 0 ? void 0 : ref.tag) || "";
                        value.type = row.rowType;
                        v.value = JSON.stringify(value);
                    }
                } catch (e) {
                    console.log("Error assigning id for", v);
                }
            });
        }
        if (!((ref3 = row.options) === null || ref3 === void 0 ? void 0 : ref3.hasQuestionnaire) && ((ref4 = row.options) === null || ref4 === void 0 ? void 0 : ref4.isInHeader)) {
            rowsInHeader.push(row);
        }
        if ((ref5 = row.options) === null || ref5 === void 0 ? void 0 : ref5.isSearchable) {
            var ref10;
            if (Array.isArray(row.control)) {
                row.control.forEach(function(con) {
                    var currentControl = typeof con === "string" ? JSON.parse(con) : con;
                    customSearchable = "".concat(customSearchable, " ").concat(currentControl.label);
                });
            } else if (typeof row.control !== "string") {
                if (row.control && row.control.label) {
                    customSearchable = "".concat(customSearchable, " ").concat(row.control.label);
                }
            } else {
                customSearchable = "".concat(customSearchable, " ").concat(row.control);
            }
            if ((ref10 = row.options.items) === null || ref10 === void 0 ? void 0 : ref10.length) {
                row.options.items.forEach(function(item) {
                    customSearchable = "".concat(customSearchable, " ").concat(item.label);
                });
            }
        }
        return true;
    });
    item.rows = validRows;
    item.tabs = tabs;
    item.rowsInHeader = rowsInHeader;
    item.customSearchable = customSearchable;
    item.pricing = {
        value: priceValue || 0,
        label: priceLabel
    };
    item.values = {};
    context.utils.product.request.postTransformProduct(item);
    return item;
};
var transformCatalog = function(catalog) {
    var ref;
    if (!catalog.contents) {
        catalog.contents = {
            items: []
        };
    }
    catalog.contents.items = ((ref = catalog.contents) === null || ref === void 0 ? void 0 : ref.items.map(function(item, index) {
        return transformProduct(item, {
            supplierName: catalog.name || "",
            catalogId: catalog.id,
            order: index + 1
        });
    })) || [];
    return catalog;
};
var retrieveCategoriesAndFilters = function(catalog) {
    var ref;
    var categories = [];
    var filters = [];
    var filtersGroups = [];
    (ref = catalog.contents) === null || ref === void 0 ? void 0 : ref.items.forEach(function(product) {
        product.categories.forEach(function(category) {
            category.label = category.name;
            category.value = category.id;
            categories.push(category);
            if (category.parentCategoryId) {
                categories.push({
                    name: category.parentName,
                    id: category.parentCategoryId,
                    label: category.parentName,
                    value: category.parentCategoryId
                });
            }
        });
        categories.push({
            id: "category-undefined",
            value: "category-undefined",
            label: "Other Products",
            name: "Other Products"
        });
        if (product.filters) {
            product.filters.forEach(function(filter) {
                filter.label = filter.name;
                filter.value = filter.id;
                filter.parent_name = filter.parent_name || filter.parentName;
                filter.parent_id = filter.parent_id || filter.parentId;
                filtersGroups.push({
                    label: filter.parent_name,
                    id: filter.parent_id,
                    position: filter.parentPos,
                    options: []
                });
                filters.push(filter);
            });
        }
    });
    filtersGroups = sortBy(uniqueArrayById(filtersGroups), "position");
    filtersGroups.forEach(function(filterGroup) {
        var options = uniqueArrayById(filters).filter(function(filter) {
            return filter.parent_id === filterGroup.id;
        });
        filterGroup.options = sortBy(options, "pos");
    });
    return {
        categories: uniqueArrayById(categories),
        filters: uniqueArrayById(filtersGroups)
    };
};
// This will be fetched only once! Subsequent requests will be returned from the context state.
export var fetchProductsByCatalogId = function(catalogId) {
    var cachedCatalog = context.state.catalogs.find(function(cat) {
        return cat.id === catalogId;
    });
    return cachedCatalog ? {
        value: cachedCatalog
    } : {
        url: "".concat(context.constants.host, "/beta/catalogs/").concat(catalogId),
        comparison: catalogId,
        then: function(param) {
            var data = param.data;
            data = transformCatalog(data);
            var ref = retrieveCategoriesAndFilters(data), categories = ref.categories, filters = ref.filters;
            updateContextState(function(state) {
                state.catalogs = _toConsumableArray(state.catalogs).concat([
                    data
                ]);
                state.categories = dedupeCategories(_toConsumableArray(state.categories).concat(_toConsumableArray(categories)));
                state.filters = _toConsumableArray(state.filters).concat(_toConsumableArray(filters));
            });
            return {
                value: data
            };
        }
    };
};
export var fetchProductById = function(id) {
    return {
        url: "".concat(context.constants.host, "/beta/products/").concat(id, "?populateRows=true"),
        method: "GET",
        comparison: id,
        then: function(param) {
            var product = param.data;
            if (!product) {
                return {
                    value: Promise.reject(new Error("Product not found"))
                };
            }
            return {
                value: transformProduct(product)
            };
        }
    };
};
export var fetchCatalogInfoById = function(catalogId) {
    return {
        url: "".concat(context.constants.host, "/beta/catalogs/").concat(catalogId, "/info"),
        method: "GET",
        comparison: catalogId,
        then: function(param) {
            var catalogInfo = param.data;
            if (!catalogInfo) {
                return {
                    value: Promise.reject(new Error("Catalog not found"))
                };
            } else {
                return {
                    value: catalogInfo
                };
            }
        }
    };
};
export var submitFeedback = function(data) {
    return {
        submission: {
            url: "".concat(context.constants.appHost, "/api/v1/feedbacks/create"),
            method: "POST",
            body: JSON.stringify({
                data: _objectSpread({
                    companyId: context.constants.client.companyId,
                    userName: safeGet(context.state, "user.email")
                }, pick(data, "objectId", "objectType", "objectName", "question", "response", "comments"))
            })
        }
    };
};
